import React, { Component } from 'react';
import { Col, DatePicker, Row, Select, Table } from 'antd';
import { withRouter } from 'react-router-dom';
import numeral from 'numeral';
import _ from 'lodash';

import * as customerController from '../../../../../../services/api/customer';
import * as programmeController from '../../../../../../services/api/programme';
import * as channelController from '../../../../../../services/api/channel';
import './CustomerRanking.scss';

const { Option } = Select;
const { RangePicker } = DatePicker;

export class CustomerRanking extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            programmes: [],
            selectedProgrammes: [],
            channels: [],
            selectedChannels: [],
            selectedDateRanges: [],
            rankings: [],
            pagination: {
                pageSize: 10,
                current: 1
            }
        }
    }

    fetchProgrammes() {
        this.setState({ isLoading: true });

        programmeController.getProgrammes({ isSimple: true })
            .then((res) => res.json())
            .then((json) => this.setState({ programmes: json, isLoading: false }))
    }

    fetchChannels() {
        this.setState({ isLoading: true });

        channelController.getChannels({ isSimple: true })
            .then((res) => res.json())
            .then((json) => this.setState({ channels: json, isLoading: false }))
    }

    fetchRankings() {
        const { selectedProgrammes, selectedChannels, selectedDateRanges } = this.state;

        this.setState({ isLoading: true });

        customerController.getRanking({
                programme_ids: selectedProgrammes,
                channel_ids: selectedChannels,
                since: selectedDateRanges[0] && selectedDateRanges[0].startOf('day').toISOString(),
                until: selectedDateRanges[1] && selectedDateRanges[1].endOf('day').toISOString()
            })
            .then((res) => res.json())
            .then((json) => this.setState({ rankings: json, isLoading: false }))
    }

    componentDidMount() {
        this.fetchProgrammes();
        this.fetchChannels();
        this.fetchRankings();
    }

    componentDidUpdate(prevProps, prevState) {
        const { selectedProgrammes, selectedChannels, selectedDateRanges } = this.state;

        if (!_.isEqual(selectedProgrammes, prevState.selectedProgrammes) ||
            !_.isEqual(selectedChannels, prevState.selectedChannels) ||
            !_.isEqual(selectedDateRanges, prevState.selectedDateRanges))
            this.fetchRankings();
    }

    render() {
        const { history } = this.props;
        const { programmes, selectedProgrammes, channels, selectedChannels, selectedDateRanges, rankings, pagination, isLoading } = this.state;

        const programmeOptions = _.map(programmes, (programme) => <Option key={programme.id} value={programme.id}>{programme.name}</Option>);
        const channelOptions = _.map(channels, (channel) => <Option key={channel.id} value={channel.id}>{channel.name}</Option>);

        const enrollmentColumns = [{
            title: '',
            dataIndex: 'ranking',
            key: 'ranking',
            align: 'center',
            render: (text, record, index) => (pagination.current - 1) * pagination.pageSize + index + 1
        }, {
            title: 'Name',
            dataIndex: 'name',
            key: 'name'
        }, {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        }, {
            title: 'Contact Number',
            dataIndex: 'contact_number',
            key: 'contact_number',
        }, {
            title: '# of Enrollment',
            dataIndex: 'number_of_enrolled_lead',
            key: 'number_of_enrolled_lead',
            align: 'center',
        }, {
            title: '# of Lead',
            dataIndex: 'number_of_lead',
            key: 'number_of_lead',
            align: 'center',
        }, {
            title: 'Enrollment %',
            dataIndex: 'enrollment_percentage',
            key: 'enrollment_percentage',
            align: 'center',
            render: (text) => numeral(text).format('0.[00]%')
        }];

        return (
            <div className="CustomerRanking">
                <Row className="option-bar">
                    <Col span={24}>
                        <div className="query-option">
                            <label>Programme(s): </label>
                            <Select
                                mode="multiple"
                                style={{ width: 200 }}
                                placeholder="(All)"
                                value={selectedProgrammes}
                                onChange={(value) => this.setState({ selectedProgrammes: value} )}
                            >
                                {programmeOptions}
                            </Select>
                        </div>
                        {" "}
                        <div className="query-option">
                            <label>Channel(s): </label>
                            <Select
                                mode="multiple"
                                style={{ width: 200 }}
                                placeholder="(All)"
                                value={selectedChannels}
                                onChange={(value) => this.setState({ selectedChannels: value} )}
                            >
                                {channelOptions}
                            </Select>
                        </div>
                        {" "}
                        <div className="query-option">
                            <label>Date Range: </label>
                            <RangePicker
                                value={selectedDateRanges}
                                onChange={(dates, dateStrings) => this.setState({ selectedDateRanges: dates })}
                            />
                        </div>
                    </Col>
                </Row>
            	<Row>
                	<Col span={24}>
                		<div className="ranking-section">
	                		<div className="ranking-table">
		                		<Table
                                    loading={isLoading}
				                    rowKey="id"
				                    columns={enrollmentColumns}
				                    dataSource={rankings}
                                    pagination={pagination}
                                    onRow={(row) => ({
                                        onClick: () => history.push(`/dashboard/admin/customer/${row.id}`)
                                    })}
                                    onChange={(pagination, filters, sorter) => this.setState({ pagination })}
		                		/>
	                		</div>
                		</div>
                	</Col>
            	</Row>
            </div>
        );
    }
}

export default withRouter(CustomerRanking);


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/CustomerPage/components/CustomerRanking/CustomerRanking.js